import React, { useEffect } from 'react';
import { setPainStatusButton, wellCheckNess } from '@stores/onBoard/onBoard';
import { useTypedDispatch, useTypedSelector } from '@stores/index';
import { PATIENT_ONBOARD, PLANS } from '@stores/constants';
import { updatePlanByUserId } from '@stores/settings/setings';

export interface FeatureProps {
	title: string;
	option: string;
	planType: string;
	imageSrc: string;
	setProgressPercent: (value: number) => void;
	setActiveStep: (value: number) => void;
	backgroundStyle: string;
	hoverBackgroundStyle: string;
}

const FeatureCard = (props: FeatureProps) => {

	const {title, option, planType, hoverBackgroundStyle, backgroundStyle, imageSrc, setProgressPercent, setActiveStep } = props;
	const dispatch = useTypedDispatch();
	const user = useTypedSelector(state => state.user);
	const [selectedPlan, setSelectedPlan] = React.useState<string>('');

	useEffect(() => {
		setSelectedPlan(planType);
	}, [planType]);

	const handleOptions = (str: string) => {
  const formattedStr = str
    .replace(/<p>/g, '<li style="margin-bottom: 10px; text-align: left">')
    .replace(/<\/p>/g, '</li>');
  
  return <ul style={{listStyle:'disc'}} dangerouslySetInnerHTML={{ __html: formattedStr }} />;
};

	return (
		<div
			className="feature-card cursor-pointer rounded-[20px] bg-transparent"
			style={{ height: 'max-content', width: '358px' }}
			onClick={async () => {
				if (selectedPlan != PATIENT_ONBOARD.VIRTUAL_PT) {
					setProgressPercent(50);
					setActiveStep(5);
					dispatch(setPainStatusButton(PATIENT_ONBOARD.NO_PAIN));
					const params = { userId: user?.id, isWellCheckNess: true };
					await dispatch(wellCheckNess(params));
					dispatch(updatePlanByUserId({ userId: user?.id, planType: selectedPlan }))
				} else {
					setProgressPercent(30);
					setActiveStep(3);
					dispatch(setPainStatusButton(''));
					const params = { userId: user?.id, isWellCheckNess: false };
					await dispatch(wellCheckNess(params));
					dispatch(updatePlanByUserId({ userId: user?.id, planType: PLANS.VIRTUALPT }))
				}
			}}>
			<div className="flip-container">
				<div
					style={{
						backgroundImage: `url(${imageSrc})`,
					}}
					className="flip-container-front">
					<div
						style={{
							background: backgroundStyle,
						}}
						className="flip-container-front-title">
						{title?.toUpperCase()}
					</div>
				</div>
				<div
					style={{
						backgroundImage: `url(${imageSrc})`,
						transition: 'transform 0.6s ease, opacity 0.6s ease',
					}}
					className="flip-container-back">
					<div
						style={{
							background: hoverBackgroundStyle,
						}}
						className="flip-container-back-content">
						<span
							style={{
								color: 'white',
								fontSize: '22px',
								fontWeight: 'lighter',
							}}>
							{title}
						</span>
						<span>
							<div>
								<p className="flip-container-option">{handleOptions(option)}</p>
							</div>
						</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default FeatureCard;
